import React, { useEffect } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import { Box, Grid, Typography } from '@material-ui/core'
import { useRouter } from 'next/router'
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function ConfirmAge() {
  const [open, setOpen] = React.useState(false)
  const [ageNotVerified, setAgeNotVerified] = React.useState(false)
  const router = useRouter()
  let { storeSlug } = router.query

  const handleClose = verified => {
    localStorage.setItem('ageverified', verified)
    if (verified) {
      setOpen(false)
    } else {
      setAgeNotVerified(true)
    }
  }
  useEffect(function() {
    if (storeSlug) {
      localStorage.setItem('slug', storeSlug)
    }
    let verified = localStorage.getItem('ageverified')
    if (!(verified == 'true')) {
      setOpen(true)
    }
  }, [])
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title"></DialogTitle>
        <DialogContent>
          <Grid container justify-content='center' alignContent={'center'} className='justify-content-center'>
            <Grid item xs={12}>
              <Typography variant="h5" align="center">
                {'Are you over 21 years of age?'}
              </Typography>
            </Grid>
            <Box m={2}>
              <Button
                variant="contained"
                onClick={() => {
                  handleClose(false)
                }}
                color="primary"
              >
                No
              </Button>
            </Box>
            <Box m={2}>
              <Button
                variant="contained"
                onClick={() => {
                  handleClose(true)
                }}
                color="primary"
              >
                Yes
              </Button>
            </Box>
            <Grid item xs={12}>
              {ageNotVerified && (
                <Box>
                  <Typography align="center" color="error">
                    You must be at least the age of 21 to access this website.
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  )
}